import BraedcrumbIcon from './../../assets/img/dash.png';
import { Link } from 'react-router-dom';
export default function Breadcrumb({ page }) {
  return (
    <div className="breadcrumb-path ">
      <ul className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/dashboard">
            <img src={BraedcrumbIcon} className="mr-3" alt="breadcrumb" />
            Home
          </Link>
        </li>
        <li className="breadcrumb-item active">{page}</li>
      </ul>
      <h3>{page}</h3>
    </div>
  );
}
